import api from './api';

export const menuService = {
    // Get all menus (tree structure)
    getMenus: async () => {
        try {
            const response = await api.get('/menus');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data menu'
            };
        }
    },

    // Create menu
    createMenu: async (menuData) => {
        try {
            const response = await api.post('/menus', menuData);
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal membuat menu'
            };
        }
    },

    // Update menu
    updateMenu: async (id, menuData) => {
        try {
            const response = await api.put(`/menus/${id}`, menuData);
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate menu'
            };
        }
    },

    // Delete menu
    deleteMenu: async (id) => {
        try {
            const response = await api.delete(`/menus/${id}`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menghapus menu'
            };
        }
    },

    // Get roles (untuk assignment)
    getRoles: async () => {
        try {
            const response = await api.get('/roles');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data role'
            };
        }
    }
};